import React from 'react'
import { MessageSearch } from 'iconsax-react'
import { useTheme } from '@mui/material'

import SearchModal from './SearchModal'

import useStyles from './styles'

type SearchProps = {
  session: string
  isDirect: boolean
}

const Search: React.FC<SearchProps> = ({ session, isDirect }) => {
  const theme = useTheme()

  const [modalOpen, setModalOpen] = React.useState(false)

  const classes = useStyles()

  const openModal = React.useCallback(() => {
    setModalOpen(true)
  }, [])

  const closeModal = React.useCallback(() => {
    setModalOpen(false)
  }, [])

  return (
    <div className={classes.root}>
      <div className={classes.iconRoot}>
        <MessageSearch
          size={theme.size.base}
          onClick={openModal}
          className={classes.icon}
        />
      </div>

      {modalOpen && (
        <SearchModal
          session={session}
          isDirect={isDirect}
          onClose={closeModal}
        />
      )}
    </div>
  )
}

export default Search
